export default __webpack_public_path__ + "static/media/44.4988d193.jpg";